/**
 * Maps the persisted reaction value (`love` / `neutral` / `not_me`) to the
 * single-character icon the Board Editor renders on image footers.
 *
 * Note: the editor itself only renders the icon variant — the full label
 * mode (mood / simple / decision) lives in `utils/reactionLabels.js` and is
 * consumed by `SortableImageCard` directly.
 */
export const getReactionIcon = (reaction) => {
  switch (reaction) {
    case 'love': return '❤️';
    case 'neutral': return '👍';
    case 'not_me': return '❌';
    default: return null;
  }
};
